module.exports = __webpack_public_path__ + "img/lanren.f45c6ff6.png";